import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function (options) {
  swan.switchTab(options);
}, CONTAINER_NAME.BAIDU);
export default switchTab;